export default function MultiselectDropdown() {
    const $selectWrapper = $('.staff-filter').not('.is-loading')
    const $select = $selectWrapper.find('.form-input.select select[multiple]')
    const $dropdown = $selectWrapper.find('.multiselect-dropdown')
    const $placeholder = $dropdown.find('.placeholder')
    const $listWrapper = $dropdown.find('.multiselect-dropdown-list-wrapper')
    const $list = $dropdown.find('.multiselect-dropdown-list')
    function toggleDropdown(e) {
        if (!$listWrapper.has(e.target).length) {
            $listWrapper.toggle()
        }
    }

    function updateDisplay() {
        const selected = $select.find('option:selected')
        $dropdown.find('.optext').remove()

        if (selected.length === 0) {
            $placeholder.show()
        } else {
            $placeholder.hide()
            if (selected.length >= 4) {
                $('<span>', {
                    class: 'optext maxselected',
                    text: `${selected.length} selected`,
                }).insertBefore($listWrapper)
            } else {
                selected.each((i, option) => {
                    $('<span>', {
                        class: 'optext',
                        html: `<span class="optextitem">${option.textContent}</span><span class="optdel" title="Remove">×</span>`,
                    }).insertBefore($listWrapper)
                })
            }
        }
    }

    function handleDelete(e) {
        const $target = $(e.target)

        if (!$target.hasClass('optdel')) return

        const text = $target.closest('.optext').find('.optextitem').text().trim()

        const option = $select.find('option').filter((i, opt) => opt.textContent === text)[0]

        const $checkbox = $list
            .find('label')
            .filter(function () {
                return $(this).text() === text
            })
            .prev('input')

        if (option && $checkbox.length) {
            option.selected = false
            $select[0].dispatchEvent(new Event('change'))
            $checkbox.prop('checked', false).parent().removeClass('checked')
            updateDisplay()

            $selectWrapper.addClass('is-loading')
        }

        e.stopPropagation()
    }

    function handleCheckboxClick(e) {
        const $wrapper = $(this)
        const $checkbox = $wrapper.find('input')
        const $label = $wrapper.find('label')

        const option = $select.find('option').filter((i, opt) => opt.textContent === $label.text())[0]

        let $checked = false

        if (!$checkbox.prop('checked')) {
            $checked = true
        }

        $checkbox.prop('checked', $checked)

        $(option).prop('selected', $checked)

        $select[0].dispatchEvent(new Event('change'))

        $wrapper.toggleClass('checked', $checked)

        updateDisplay()

        $selectWrapper.addClass('is-loading')

        if ($checkbox.prop('checked')) {
            setTimeout(() => $wrapper.prependTo($list), 0)
        }

        $listWrapper.hide()
        e.stopPropagation()
    }

    function initEvents() {
        $listWrapper.hide()

        $list.find('>div').on('click', handleCheckboxClick)

        $dropdown.on('click', '.optdel', handleDelete)
        $dropdown.on('click', '.optext:not(.maxselected)', (e) => {
            e.stopPropagation()
        })

        $dropdown.on('click', toggleDropdown)

        $(document).on('click', (e) => {
            const target = $(e.target)
            if (target.closest('.multiselect-dropdown').length === 0) {
                $listWrapper.hide()
            }
        })
    }

    initEvents()
}
